import styles from './InputWrapper.module.css';

interface InputWrapperProps extends React.HTMLAttributes<HTMLDivElement> {}

const InputWrapper = ({ className, ...props }: InputWrapperProps): React.JSX.Element => (
    <div className={`${styles.inputWrapper}${className ? ` ${className}` : ''}`} {...props} />
);

export { InputWrapper };
